import React,{useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import PersonIcon from '@material-ui/icons/Person';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import MenuIcon from '@material-ui/icons/Menu'
import LensIcon from '@material-ui/icons/Lens';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles} from '@material-ui/core/styles';
import PopUp from './PopUp';

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: '#03a9f4',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  keyIcon: {
    marginRight: theme.spacing(1),
  },
  personIcon: {
    marginRight: theme.spacing(1),
  },
  onlineIcon: {
    color: '	#25D366',
    width: 8,
  },
  title: {
    flexGrow: 1,
  },
  innerMenu:{
    maxHeight: 'auto',
    maxWidth: 'auto',
  },
}));

export default function NavBar ({users}){

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return(
    <AppBar position='static' className={classes.appBar}>
      <Toolbar>
        <IconButton 
          edge="start" 
          className={classes.menuButton} 
          color="inherit" 
          aria-controls="menu"
          aria-label="menu"
          onClick={handleClick}
        >
          <MenuIcon />
        </IconButton>
        <Menu
        id="menu"
        anchorEl={anchorEl}
        className={classes.innerMenu}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        >
          <CopyToClipboard text={users? users[0]['token'] : null}>
            <MenuItem 
              onClick={()=>{          
                setShowPopUp(true);
                setTimeout(()=>{setShowPopUp(false)}, 4000);                
              }}>
              <VpnKeyIcon className={classes.keyIcon}/> {users? users[0]['token'] : null}
            </MenuItem>
          </CopyToClipboard>
          {
          users ? users.map(({name})=>(
            <MenuItem key={name} onClick={handleClose}>
              <PersonIcon className={classes.personIcon}/>{name}
            </MenuItem>
          )): null } 
        </Menu>
        <Typography variant="h6" className={classes.title}>
          Room {users? users[0]['room'] : null}
        </Typography>
        <LensIcon className={classes.onlineIcon}/>
          <Button color="inherit" href='/'>Exit Room</Button> 
      </Toolbar>
      {showPopUp? <PopUp type='chat'/>: null}
    </AppBar>
  )
}